import styled from '@emotion/styled';

export const Container = styled.div<{ isOpen: boolean; color: string }>`
  position: relative;
  width: 100%;
  height: 50px;

  padding: 0 17px 0 12px;

  display: flex;
  justify-content: space-between;
  align-items: center;

  font-size: 14px;
  font-weight: 400;

  transition: all 0.2s ease;

  cursor: pointer;
  background: ${({ color }): string => color};
`;

export const Label = styled.p`
  font-size: 14px;
  color: ${({ theme }): string => theme.BLACK};
  background-color: ${({ theme }): string => theme.WHITE};
  padding: 5px;
  border-radius: 5px;
  font-weight: 600;
`;

export const Arrow = styled.div<{ isOpen: boolean }>`
  transition: all 0.2s ease;
  transform: ${({ isOpen }): string => (isOpen ? 'rotate(-90deg)' : 'rotate(0deg)')};
  fill: white !important;
  stroke: white !important;
`;

export const Content = styled.div<{ isOpen: boolean; color: string }>`
  width: 100%;
  max-height: ${({ isOpen }): string => (isOpen ? '800px' : '0px')};
  padding-top: ${({ isOpen }): string => (isOpen ? '10px' : '0px')};
  transition: all 0.2s ease;
  overflow: hidden;
  border-left: 4px solid ${({ color }): string => color};
`;
